import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./bottomnav.css";
import * as Icon from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

function BottomNav() {
  const [activeTab, setActiveTab] = useState("home");
  const [showProducts, setShowProducts] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // ✅ REAL CART DATA FROM REDUX
  const { items, itemCount } = useSelector((state) => state.cart);

  const categories = [
    "Maternity Wear",
    "Lounge Wear",
    "Palazzo Pants",
    "CO-ORD Set",
    "Jeggings",
    "Kurthis",
    "Ladies Tops",
    "Men",
    "Kids",
    "Coming Soon",
  ];

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      {/* Bottom Navigation */}
      <div className="b-nvaigation">
        <ul style={{ paddingLeft: 0 }}>

          {/* HOME */}
          <li className={"list " + (activeTab === "home" ? "active" : "")}>
            <a
              href=""
              onClick={(e) => {
                e.preventDefault();
                handleTabChange("home");
                navigate("/");
              }}
            >
              <span className="icon">
                <Icon.House className="b-icon" size={20} />
              </span>
              <span className="text">Home</span>
            </a>
          </li>

          {/* PRODUCTS */}
          <li className={"list " + (activeTab === "products" ? "active" : "")}>
            <a
              href=""
              onClick={(e) => {
                e.preventDefault();
                handleTabChange("products");
                setShowProducts(true);
              }}
            >
              <span className="icon">
                <Icon.Storefront className="b-icon" size={20} />
              </span>
              <span className="text">Products</span>
            </a>
          </li>

          {/* WISHLIST */}
          <li className={"list " + (activeTab === "wishlist" ? "active" : "")}>
            <a
              href=""
              onClick={(e) => {
                e.preventDefault();
                handleTabChange("wishlist");
                navigate("/wishlist");
              }}
            >
              <span className="icon">
                <Icon.Heart className="b-icon" size={20} />
              </span>
              <span className="text">Wishlist</span>
            </a>
          </li>

          {/* CART */}
          <li className={"list " + (activeTab === "cart" ? "active" : "")}>
            <a
              href=""
              onClick={(e) => {
                e.preventDefault();
                handleTabChange("cart");
                navigate("/cart");
              }}
            >
              <span className="icon" style={{ position: "relative" }}>
                <Icon.ShoppingCart className="b-icon" size={20} />

                {/* 🔥 CART COUNT BADGE */}
                <span
                  style={{
                    position: "absolute",
                    right: "-6px",
                    top: "-3px",
                    background: "var(--cr-red-logo)",
                    color: "#fff",
                    width: "18px",
                    height: "18px",
                    fontSize: "12px",
                    display: itemCount > 0 ? "flex" : "none",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "50%",
                  }}
                >
                  {itemCount}
                </span>
              </span>

              <span className="text">Cart</span>
            </a>
          </li>

          {/* PROFILE */}
          <li className={"list " + (activeTab === "profile" ? "active" : "")}>
            <a
              href=""
              onClick={(e) => {
                e.preventDefault();
                handleTabChange("profile");
                navigate("/account");
              }}
            >
              <span className="icon">
                <Icon.User className="b-icon" size={20} />
              </span>
              <span className="text">Profile</span>
            </a>
          </li>
        </ul>
      </div>

      {/* PRODUCTS POPOVER */}
      {showProducts && (
        <div
          className="products-popover-overlay"
          onClick={() => setShowProducts(false)}
        >
          <div
            className="products-popover"
            onClick={(e) => e.stopPropagation()}
          >
            <h4 className="popover-title">Select Category</h4>

            <ul className="popover-list">
              {categories.map((cat) => (
                <li
                  key={cat}
                  className="popover-item"
                  onClick={() => {
                    navigate(`/shop?category=${encodeURIComponent(cat)}`);
                    setShowProducts(false);
                  }}
                >
                  {cat}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  );
}

export default BottomNav;
